import FingerprintIcon from '@material-ui/icons/Fingerprint';
export const RijksregisterNummerIcon = FingerprintIcon;

